import React from "react";
import About from "../assests/IMG_8479.jpeg";

const Training = () => {
  return (
    <div
      name="Training"
      className="w-screen md:w-full h-full  "
      style={{ backgroundImage: `url(${About})` }}
    >
      {/** Container */}
      <div className="bg-white bg-opacity-90  max-w-[1000px] mx-auto gp-opacity-50 p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8 pt-32">
          <p className="text-4xl text-center font-bold  text-[#001ea1]">
            General and Comrades Training
          </p>
          <p className=" font-bold pt-4 text-red-700">
            Join us for our weekly runs! No membership is required to
            participate in our training sessions. Let’s Level Up together!
          </p>

          <p className=" pt-7    text-[#001ea1] flex">
            <p className="font-bold pr-12 flex">
              <li></li> <p> Monday: </p>
            </p>
            <p className="inline pl-5"> Rest / Cross Training / Easy 8km </p>
          </p>
          <p className=" pt-7    text-[#001ea1] flex">
            <p className="font-bold pr-12 flex">
              <li></li> <p> Tuesday: </p>
            </p>
            <p className="inline pl-5"> 1/2km WA, 4/8km TT </p>
          </p>
          <p className=" pt-7    text-[#001ea1] flex">
            <p className="font-bold pr-10 flex">
              <li></li> <p>Wednesday: </p>
            </p>
            <p className="inline"> 8/10/12/15km LSD </p>
          </p>
          <p className=" pt-7    text-[#001ea1] flex">
            <p className="font-bold pr-10 flex">
              <li></li> <p>Thursday: </p>
            </p>
            <p className="inline pl-5"> Hill Repeats </p>
          </p>
          <p className=" pt-7  text-[#001ea1] flex">
            <p className="font-bold pr-9 flex">
              <li></li> <p>Friday: </p>
            </p>
            <p className="inline pl-12"> 8km Social Run / Rest / Cross Train</p>
          </p>
          <p className=" pt-7  text-[#001ea1] flex">
            <p className="font-bold pr-16 flex">
              <li></li> <p>Saturday: </p>
            </p>
            <p className="inline"> 15/18/21/24/28/32/36km LSD</p>
          </p>
          <p className=" pt-7  text-[#001ea1] flex">
            <p className="font-bold pr-20 flex">
              <li></li> <p>Sunday: </p>
            </p>
            <p className="inline"> 8/10/12/15km Recovery Run</p>
          </p>
        </div>
      </div>
      <div className="max-w-[1000px] bg-white bg-opacity-90 mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8 ">
          <p className="text-4xl text-center font- font-bold  text-[#001ea1]">
            Trainning Times and locations
          </p>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-12 flex h-full">
              <li></li> <p>Monday: </p>
            </p>
            <p className="inline h-full"> 04:45 Sunward Park Shell Garage</p>
          </div>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-12 flex h-full">
              <li></li> <p>Tuesday: </p>
            </p>
            <p className="inline h-full"> 04:45 Sunward Park Shell Garage</p>
          </div>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-5 flex h-full">
              <li></li> <p>Wednesday: </p>
            </p>
            <p className="inline h-full"> 04:45 Sunward Park Shell Garage</p>
          </div>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-10 flex h-full">
              <li></li> <p>Thursday: </p>
            </p>
            <p className="inline h-full"> 04:45 Astron Farrar Park</p>
          </div>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-16 flex h-full">
              <li></li> <p>Friday: </p>
            </p>
            <p className="inline h-full"> 04:45 Sunward Park Shell Garage</p>
          </div>
          <div className=" pt-7 h-full items-center text-[#001ea1] flex">
            <p className="font-bold pr-11 flex h-full">
              <li></li> <p>Saturday: </p>
            </p>
            <p className="inline h-full"> 05:00 Meadowdale shoppping center</p>
          </div>
          <div className=" pt-7 h-full  items-center text-[#001ea1] flex">
            <p className="font-bold pr-14 flex h-full">
              <li></li> <p>Sunday: </p>
            </p>
            <p className="inline h-full"> 04:45 Sunward Park Virgin Active</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Training;
